module.exports = __webpack_public_path__ + "img/title_en@2x.b7a0ad19.png";